import { c as _c } from "react/compiler-runtime";
import type { CustomField } from "@spree/sdk";
import { useTranslations } from "next-intl";
import { isGoogleFeedField } from "@/lib/google-merchant";
interface ProductCustomFieldsProps {
  customFields?: Array<CustomField>;
}
function renderBooleanValue(value: unknown, t: ReturnType<typeof useTranslations<"products">>): React.ReactNode {
  return value ? t("yes") : t("no");
}

// Spree 6 names the type in `field_type` (short_text, long_text, rich_text,
// number, boolean, json). 5.x sent a class name in `type`, which 6.0 dropped.
function renderValue(field: CustomField, t: ReturnType<typeof useTranslations<"products">>): React.ReactNode {
  switch (field.field_type) {
    case "boolean":
      return renderBooleanValue(field.value, t);
    case "json":
      return typeof field.value === "string" ? field.value : JSON.stringify(field.value);
    case "rich_text":
      // Value is admin-authored HTML from the Spree CMS backend (trusted source)
      return <span dangerouslySetInnerHTML={{
        __html: field.value
      }} />;
    default:
      return String(field.value);
  }
}
export function ProductCustomFields(t0) {
  const $ = _c(20);
  const {
    customFields
  } = t0;
  const t = useTranslations("products");
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== customFields || $[1] !== t) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const visibleFields = customFields?.filter(_temp);
      if (!visibleFields || visibleFields.length === 0) {
        t5 = null;
        break bb0;
      }
      t3 = "mt-8 border-t pt-8";
      let t6;
      if ($[7] !== t) {
        t6 = t("properties");
        $[7] = t;
        $[8] = t6;
      } else {
        t6 = $[8];
      }
      if ($[9] !== t6) {
        t4 = <h2 className="text-lg font-medium text-gray-900 mb-4">{t6}</h2>;
        $[9] = t6;
        $[10] = t4;
      } else {
        t4 = $[10];
      }
      t1 = "space-y-3";
      let t7;
      if ($[11] !== t) {
        t7 = field => <div key={field.id} className="flex"><dt className="w-32 shrink-0 text-gray-500 text-sm">{field.label}</dt><dd className="text-gray-900 text-sm min-w-0">{renderValue(field, t)}</dd></div>;
        $[11] = t;
        $[12] = t7;
      } else {
        t7 = $[12];
      }
      t2 = visibleFields.map(t7);
    }
    $[0] = customFields;
    $[1] = t;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[13] !== t1 || $[14] !== t2) {
    t6 = <dl className={t1}>{t2}</dl>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t6) {
    t7 = <div className={t3}>{t4}{t6}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
function _temp(f) {
  return !isGoogleFeedField(f);
}